import defaultLogoUrl from '../../assets/icc-logo-transparent.png';

const env = process.env;
const lines = (value, fallback = []) => value ? value.split('|').map((item) => item.trim()).filter(Boolean) : fallback;

// Point d'entrée provisoire unique de l'identité documentaire. Une future UI
// société pourra remplacer ces valeurs sans modifier les documents métier.
const legalName = env.REACT_APP_DOCUMENT_COMPANY_LEGAL_NAME || 'Ingénierie Court-Circuit';
const legalForm = env.REACT_APP_DOCUMENT_COMPANY_LEGAL_FORM || 'SAS';
const capital = env.REACT_APP_DOCUMENT_COMPANY_CAPITAL || '';
const rcs = env.REACT_APP_DOCUMENT_COMPANY_RCS || '';
const addressLines = lines(env.REACT_APP_DOCUMENT_COMPANY_ADDRESS, [
  "Chez Art'Immo – Bâtiment La Géode",
  '10 allée des Artilleurs · 42000 Saint-Étienne',
]);
const legalLines = lines(env.REACT_APP_DOCUMENT_COMPANY_LEGAL, [
  'SIRET 10657502000016 · TVA FR74106575020',
]);

const defaultFooterLegalLines = [
  [legalName, legalForm, capital ? `au capital de ${capital}` : '', rcs].filter(Boolean).join(' · '),
  ...addressLines,
  ...legalLines,
].filter(Boolean);

export const companyDocumentIdentity = {
  shortName: env.REACT_APP_DOCUMENT_COMPANY_SHORT_NAME || 'ICC',
  displayName: env.REACT_APP_DOCUMENT_COMPANY_NAME || 'ICC · Ingénierie Court-Circuit',
  legalName,
  legalForm,
  capital,
  rcs,
  descriptor: env.REACT_APP_DOCUMENT_COMPANY_DESCRIPTOR || 'Bureau d’études en génie électrique',
  logoUrl: env.REACT_APP_DOCUMENT_COMPANY_LOGO || defaultLogoUrl,
  addressLines,
  contactLines: lines(env.REACT_APP_DOCUMENT_COMPANY_CONTACT),
  legalLines,
  footerLegalLines: lines(env.REACT_APP_DOCUMENT_COMPANY_FOOTER_LEGAL, defaultFooterLegalLines),
};

export { documentTheme } from './documentTheme';

